
export const AllocateAdSpendSwitcher = ({
    checked,
    access,
    setChecked
}) => {
    return (
        <>
            <div className="relative">
                <div className={`flex items-center gap-2`}>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input
                            key={`${checked}`}
                            id="spend"
                            type="checkbox"
                            checked={checked}
                            onChange={() => {
                                if (access === "edit") {
                                    setChecked(!checked);
                                }
                            }}
                            className="sr-only peer"
                            disabled={access !== "edit"}
                        />
                        <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary`}></div>
                    </label>
                </div>
            </div>
            <label 
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 select-none"
                htmlFor="spend"
            >
                Allocate Ad Spend by Channel
            </label>
        </>
    )
}